var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "25px",
    viewBox: "0 0 31 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "4EC86D2E-29F3-4483-AA26-489E09CE4B6A") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-696.000000, -259.000000)",
    fillRule: "nonzero",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "paka",
    transform: "translate(697.000000, 260.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 1,
    y: 9,
    width: 27,
    height: 14
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-56",
    points: "0.6 8.84140625 8.41176758 0.9 17.2364746 0.9"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-56",
    transform: "translate(20.118237, 4.870703) scale(-1, 1) translate(-20.118237, -4.870703) ",
    points: "11.8 8.84140625 19.6117676 0.9 28.4364746 0.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7319336,1 L14.7319336,8.39160156",
    id: "Path-57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1347656,19.0146484 L18.9355469,19.0146484",
    id: "Path-58"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBox);
export default __webpack_public_path__ + "static/media/ico_box.80501aae6e8e3b9abac1236de0d43722.svg";
export { ForwardRef as ReactComponent };